import { JSX } from "react";


export default function NoDataFound(): JSX.Element {
  return (
    <p className="position-absolute top-50 start-50 m-0 translate-middle alert alert-warning p-2 text-center" style={{minWidth:300}}>
      No Data Available
    </p>
  );
};
